var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.932 9.97052C12.2419 8.19667 12.0936 5.68404 10.487 4.07747C8.71709 2.30751 5.84742 2.30751 4.07747 4.07747C2.30751 5.84742 2.30751 8.71709 4.07747 10.487C5.68404 12.0936 8.19667 12.2419 9.97052 10.932L12.0894 13.0509C12.3549 13.3164 12.7854 13.3164 13.0509 13.0509C13.3164 12.7854 13.3164 12.3549 13.0509 12.0894L10.932 9.97052ZM9.52561 5.0389C10.7646 6.27787 10.7646 8.28664 9.52561 9.52561C8.28664 10.7646 6.27787 10.7646 5.0389 9.52561C3.79993 8.28664 3.79993 6.27787 5.0389 5.0389C6.27787 3.79993 8.28664 3.79993 9.52561 5.0389Z",
    fill: "#7E86A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.25bdc8eeefda269805b65ff8cd981717.svg";
export { ForwardRef as ReactComponent };